module.exports = __webpack_public_path__ + "media/images/focus-wheel-example-01e6dde4ac56bf59f03dd38868302f51.jpg";